import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/HomepageS10.css";

export default function HomepageS10() {
  /*
   * Keep only selected, current items from the
   * Insights, News & Events hub in this array.
   *
   * The slice below prevents more than three cards
   * from appearing on the homepage.
   */
  const selectedInsights = [
    {
      category: "Research Update",
      title: "Advancing Global Approaches to OSH Measurement",
      summary:
        "Explore current work focused on credible, practical, and internationally informed approaches to safety measurement.",
      image: "/assets/image1.jpg",
      date: "Current Activity",
      // link: "/blog/global-osh-metrics",
    },
    {
      category: "Digital Learning",
      title: "Exploring the Future of Immersive Safety Learning",
      summary:
        "See how consultation, research, and pilot development are shaping new approaches to digital and immersive learning.",
      image: "/assets/2vr.jpg",
      date: "Consultation Update",
      link: "/blog/digital-immersive-learning",
    },
    {
      category: "Leadership Forum",
      title: "Connecting Canadian BioPharma EHS Leaders",
      summary:
        "Learn about an exploratory practitioner-led forum supporting shared insight, leadership, and industry collaboration.",
      image: "/assets/Partnership.jpg",
      date: "Featured Activity",
      link: "/blog/biopharma-ehs-forum",
    },
  ];

  const visibleInsights = selectedInsights.slice(0, 3);

  return (
    <>
      {/* HOMEPAGE SECTION 10 */}
      {/* <section
        id="latest-insights"
        className="homepage-s10"
        aria-labelledby="homepage-s10-title"
      >
        <div className="homepage-s10-background" aria-hidden="true">
          <span className="homepage-s10-glow homepage-s10-glow-left"></span>
          <span className="homepage-s10-glow homepage-s10-glow-right"></span>
        </div>

        <div className="homepage-s10-container">
          <div className="homepage-s10-header">
            <div className="homepage-s10-heading">
              <p className="homepage-s10-kicker">
                Insights, News &amp; Events
              </p>

              <h2 id="homepage-s10-title" className="homepage-s10-title">
                Latest Insights
                <span> and Activities</span>
              </h2>

              <p className="homepage-s10-intro">
                Selected updates from GESI’s research, leadership,
                collaboration, learning, and innovation activities.
              </p>
            </div>

            <NavLink
              to="/blog"
              className="homepage-s10-hub-link"
            >
              <span>View Insights, News &amp; Events</span>

              <span
                className="homepage-s10-hub-arrow"
                aria-hidden="true"
              >
                ↗
              </span>
            </NavLink>
          </div>

          <div className="homepage-s10-grid">
            {visibleInsights.map((insight, index) => (
              <article
                className="homepage-s10-card"
                key={insight.title}
              >
                <div className="homepage-s10-image-wrapper">
                  <img
                    src={insight.image}
                    alt=""
                    className="homepage-s10-image"
                    loading="lazy"
                  />

                  <div
                    className="homepage-s10-image-overlay"
                    aria-hidden="true"
                  ></div>

                  <span className="homepage-s10-category">
                    {insight.category}
                  </span>

                  <span
                    className="homepage-s10-number"
                    aria-hidden="true"
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="homepage-s10-card-content">
                  <div>
                    <p className="homepage-s10-date">
                      {insight.date}
                    </p>

                    <h3>{insight.title}</h3>

                    <p className="homepage-s10-summary">
                      {insight.summary}
                    </p>
                  </div>

                  <NavLink
                    to={insight.link}
                    className="homepage-s10-card-link"
                    aria-label={`Read more about ${insight.title}`}
                  >
                    <span>Read More</span>

                    <span
                      className="homepage-s10-card-arrow"
                      aria-hidden="true"
                    >
                      ↗
                    </span>
                  </NavLink>
                </div>

                <span
                  className="homepage-s10-card-line"
                  aria-hidden="true"
                ></span>
              </article>
            ))}
          </div>

          <NavLink
            to="/blog"
            className="homepage-s10-mobile-hub-link"
          >
            <span>View Insights, News &amp; Events</span>
            <span aria-hidden="true">→</span>
          </NavLink>
        </div>
      </section> */}

      {/* HOMEPAGE SECTION 11 */}
      <section
        id="start-a-conversation"
        className="homepage-s11"
        aria-labelledby="homepage-s11-title"
      >
        <div className="homepage-s11-background" aria-hidden="true">
          <span className="homepage-s11-orbit homepage-s11-orbit-one"></span>
          <span className="homepage-s11-orbit homepage-s11-orbit-two"></span>
          <span className="homepage-s11-glow"></span>
        </div>

        <div className="homepage-s11-container">
          <p className="homepage-s11-kicker">
            Work With GalaxyEDGE Safety
          </p>

          <h2 id="homepage-s11-title" className="homepage-s11-title">
            Build Safety into the Way
            <span> Your Organization Performs.</span>
          </h2>

          <p className="homepage-s11-description">
            Whether strengthening governance, developing capability, improving
            systems, or advancing innovation, GESI helps organizations turn
            complexity into practical action.
          </p>

          <NavLink
            to="/contact"
            className="homepage-s11-button"
          >
            <span>Start a Conversation</span>

            <span
              className="homepage-s11-button-arrow"
              aria-hidden="true"
            >
              ↗
            </span>
          </NavLink>

          <div
            className="homepage-s11-capabilities"
            aria-label="GalaxyEDGE Safety areas of support"
          >
            <span>Governance</span>
            <span>Capability</span>
            <span>Systems</span>
            <span>Innovation</span>
          </div>
        </div>
      </section>
    </>
  );
}